import React, { useEffect, useState } from 'react'
import Sidebar from './sidebarstudent'
import Header from './Headerstudent'
import { Col, Row } from 'react-bootstrap'
import { ImagePath, StudentProfileApi } from '../../ApiFile'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import MobileNavbar from './MobileNavbar'

const StudentProfile = () => {
  const navigate = useNavigate()

  const [profileData, setProfileData] = useState(null)

  const memberId = sessionStorage.getItem('member_id')

  useEffect(() => {
    fetch(`${StudentProfileApi}/${memberId}`)
      .then((response) => response.json())
      .then((data) => setProfileData(data))
      .catch((error) => console.error('Error fetching data:', error))
  }, [])

  const handleEditProfile = () => {
    navigate('/EditStudentProfile')
  }

  return (
    <>
      <div
        className="roomchange-container"
        style={{ display: 'flex', minHeight: '100vh' }}
      >
        {/* Sidebar on the left for desktop */}
        <div
          className="d-none d-md-block sidebar-container"
          style={{ width: '270px', flexShrink: 0 }}
        >
          <Sidebar />
        </div>

        {/* Main content on the right */}
        <div
          className="main-content flex-grow-1"
          style={{ flex: 1, backgroundColor: '#f8f9fa' }}
        >
          <Header />

          <div className="d-block d-md-none">
            <MobileNavbar />
          </div>

          <div
            className="border w-100 h-100 py-3"
            style={{ backgroundColor: '#f5f5f5ff' }}
          >
            <Row className="m-0  px-md-2 mt-2 rounded">
              <Col
                className="m-0 p-0 px-3 py-2 rounded"
                style={{ background: 'white' }}
              >
                <h4 style={{ color: 'maroon' }}>Profile</h4>
              </Col>
            </Row>

            {profileData ? (
              <Row className="m-0  px-md-2 mt-2 mb-5 rounded">
                <Col
                  className="m-0 p-0 px-3 py-2 rounded"
                  style={{ background: 'white' }}
                >
                  <Row className="pb-2">
                    <Col xs={5} md={3}>
                      <label>Profile Photo :</label>
                    </Col>
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={7} md={9}>
                          <img
                            src={`${ImagePath}/${profileData.image}`}
                            alt="Profile Photo"
                            className="me-5"
                            style={{
                              width: 100,
                              height: 100,
                              border: '1px solid grey',
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Name :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.name}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Father's Name :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.fatherName}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Address :</label>
                        </Col>
                        <Col
                          xs={7}
                          md={9}
                          style={{
                            flexWrap: 'wrap',
                            display: 'flex',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            maxWidth: '100%',
                          }}
                        >
                          <p>
                            {profileData.address},&nbsp;{profileData.villege}
                            ,&nbsp; Pincode: {profileData.pincode},&nbsp;
                            Taluka: {profileData.taluka}, &nbsp; District:{' '}
                            {profileData.district}, &nbsp; State:{' '}
                            {profileData.state} &nbsp;
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        <Col xs={5} md={3}>
                          <label>Email :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.email}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3} className="p-0">
                          <label>Father's Occupation :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.father_occupation}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Standard :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.std}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>College Name :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.collage_name}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Sub Category :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.sub_category}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Date of Birth :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.dateofbirth}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Age :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.age}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Mobile No :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.mob_no}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Parent's Mobile No :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.parents_mobno}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Block ID :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.block_id}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Room ID :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.room_id}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pb-2">
                    <Col>
                      <Row style={{ display: 'flex' }}>
                        <Col xs={5} md={3}>
                          <label>Bed ID :</label>
                        </Col>
                        <Col xs={7} md={9}>
                          <p>{profileData.bed_id}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="m-0 p-0 px-3 py-2">
                    <div className="text-center m-1">
                      <Button
                        style={{ backgroundColor: 'black', color: 'white' }}
                        onClick={handleEditProfile}
                      >
                        Edit Profile
                      </Button>
                    </div>
                  </Row>
                </Col>
              </Row>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default StudentProfile
